export default __webpack_public_path__ + "static/media/IMG_3980.b6db51a0.jpg";